export default __webpack_public_path__ + "static/media/iphone2.61fdd68c.svg";